var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Our Environment")]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [(_vm.servers) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.servers), function(server) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      class: 'box box-' + server.status
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('i', {
      class: 'fa fa-' + server.icon + ' fa-2x'
    }), _vm._v(" "), _c('h3', {
      staticClass: "box-title"
    }, [_vm._v(_vm._s(server.name))])]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('span', [_vm._v(_vm._s(server.description))])])])])
  })) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-359d1f73","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Server.vue
// module id = 1629
// module chunks = 1